export default __webpack_public_path__ + "static/media/exchange.5ac9efd2.png";